import { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);

    emailjs
      .sendForm("service_k2nqxew", "template_adpy4v8", e.target, "lFyZFsQFoD824CyZi")
      .then(
        (result) => {
          console.log(result.text);
          clearState();

          // Mostrar el modal de éxito
          const modal = new window.bootstrap.Modal(document.getElementById('successModal'));
          modal.show();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  // Escuchar el evento hidden.bs.modal para resetear el formulario al cerrar el modal
  useEffect(() => {
    const modalElement = document.getElementById("successModal");

    const handleModalHidden = () => {
      clearState(); // Limpia los campos del formulario
    };

    modalElement.addEventListener("hidden.bs.modal", handleModalHidden);

    return () => {
      modalElement.removeEventListener("hidden.bs.modal", handleModalHidden);
    };
  }, []);
  return (
    <div>
      <div id={props.data ? props.data.main.toLowerCase().replace(/ /g, "_") : "loading..."} className="contact">
        <div className="container">
          <div className="col-md-8 mx-auto">
            <div className="row">
              <div className="col-md-12 section-title">
                <h2> {props.data ? props.data.title : "Loading"}</h2>
              </div>
              <div className="row">
                {props.data
                  ? props.data.paragraphs.map((d, i) => (
                    <div key={`${i}`} className="col-md-12">
                      {" "}
                      <p>{d}</p>
                    </div>
                  ))
                  : "Loading..."}
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder={props.data ? props.data.fill_nombre : "/"}
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder={props.data ? props.data.fill_email : "/"}
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder={props.data ? props.data.fill_mensaje : "/"}
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Enviar mensaje
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.instagram : "/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href={`mailto:${props.data ? props.data.email : ""}`} target="_blank" rel="noreferrer">
                      <i className="fa fa-google"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.yt : "/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="successModal"
        tabIndex="-1"
        aria-labelledby="successModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="successModalLabel">
                ¡Mensaje Enviado!
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              Tu mensaje ha sido enviado exitosamente. Nos pondremos en contacto contigo pronto.
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

  );
};
